import React from 'react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../ui/alert-dialog';

export const SubmitDialog = ({ open, onOpenChange, unanswered, onConfirm }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent className="bg-white text-slate-900" data-testid="submit-confirm-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle>Submit your assessment?</AlertDialogTitle>
        <AlertDialogDescription className="text-slate-600">
          {unanswered > 0
            ? `You still have ${unanswered} unanswered item${unanswered > 1 ? 's' : ''}. Unanswered items score 0.`
            : 'Everything has an answer. You cannot change your answers after submitting.'}
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="submit-cancel-btn">Keep working</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm} className="bg-indigo-600 hover:bg-indigo-700 text-white" data-testid="submit-confirm-btn">
          Submit now
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export default SubmitDialog;
